import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const Jobs = ProtectedJsonAPI.extend(
  '/jobs',
  {
    index:   endpoint => endpoint,
    event:   endpoint => endpoint.method('post').path(({id}) => `/${id}/events`),
    types:   endpoint => endpoint.method('get').path(() => '/types'),
  }
)